import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueCookies from 'vue-cookies';
import language from './languages';

Vue.use(VueCookies);
Vue.use(VueI18n);

async function getlang () {
  const result = await language.getLanguage();
  const i18n = new VueI18n({
    locale: VueCookies.get('language') || 'en',
    fallbackLocale: VueCookies.get('language') || 'en',
    messages: result,
  });
  return i18n;
}

export const i18n = getlang;
